import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';

/** `service.manage` shows the edit controls; the server stays the authority, so this is UX only. */
export function useCanManageService(): boolean {
  const { state } = useCurrentUser();
  return state.status === 'authenticated' && state.user.permissions.includes('service.manage');
}
